export const ACTIONS = {
  CREATE_USER_PROFILE: "CREATE_USER_PROFILE",
  EDIT_USER_PROFILE: "EDIT_USER_PROFILE",
  DELETE_USER_PROFILE: "DELETE_USER_PROFILE",
  UPDATE_USER_PROFILE: "UPDATE_USER_PROFILE",
  UPDATE_AIRSYN: "UPDATE_AIRSYN",
  UPDATE_AIRSYN_READINGS: "UPDATE_AIRSYN_READINGS",
  UPDATE_PROXIE: "UPDATE_PROXIE",
};
